module.exports = "/_next/static/images/teacher-10-a776524c6fc788eed505e84ebacdbe61.png";